import React, { useCallback, useState } from "react";
import Button from "react-bootstrap/esm/Button";
import { Amenity } from "../../data";
import { useMediaQuery } from "../../hooks/use_media_query";
import { useI18n } from "../../lib/i18n/i18n_provider";
import { useAnalytics } from "../../lib/analytics/analytics";

interface AmenitiesProps {
  data: Amenity[];
  title?: string;
  description?: string;
  limit?: number;
}

export function Amenities(props: AmenitiesProps) {
  const { data, title, description, limit } = props;
  const [showAll, setShowAll] = useState(false);

  const { device } = useMediaQuery();
  const currentLimit = limit || (device === "mobile" ? 5 : 15);
  const currentAmenityList = showAll ? data : data?.slice(0, currentLimit);
  const { fbt } = useI18n();

  const analytics = useAnalytics();

  const onViewAll = useCallback(() => {
    const isShowAll = !showAll;
    setShowAll(isShowAll);

    if (isShowAll) {
      analytics.event(
        "Amenities Click",
        {
          Source: "WL",
        },
        { onlyProviders: ["mixpanel", "customerio"] }
      );
    }
  }, [analytics, showAll]);

  return (
    <div data-testid="amenities">
      <h3 className={!description ? "mb-3" : ""}>
        {title || fbt("Amenities")}
      </h3>
      {description && <p>{description}</p>}
      {currentAmenityList?.length > 0 && (
        <>
          <div className="row">
            {currentAmenityList.map((amenity, index) => {
              return (
                <div
                  key={index}
                  className="col-12 col-md-4 d-flex align-items-center mb-3"
                >
                  <img
                    alt={`${amenity.name} icon`}
                    src={amenity.iconURL}
                    className="icon amenities__icon"
                    style={{ width: 24, height: 24 }}
                  />
                  <span>{amenity.name}</span>
                </div>
              );
            })}
          </div>
          {data?.length > currentLimit && (
            <Button onClick={onViewAll} variant="outline-primary">
              {showAll ? fbt("showFewerAmenities") : fbt("showAllAmenities")}
            </Button>
          )}
        </>
      )}
    </div>
  );
}
